import React from 'react';
import { motion } from 'framer-motion';
type ProgressBarProps = {
  progress: number; // 0-100
};
export const ProgressBar: React.FC<ProgressBarProps> = ({
  progress
}) => {
  return <div className="w-full h-2 bg-[#1C2541] rounded-full mt-2 overflow-hidden" data-id="element-901">
      <motion.div className="h-full bg-gradient-to-r from-[#7D56F4] to-[#19D3DA]" initial={{
      width: 0
    }} animate={{
      width: `${progress}%`
    }} transition={{
      duration: 0.5
    }} data-id="element-902"></motion.div>
    </div>;
};